import React from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '@/lib/auth-store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export function ProtectedRoute({ children, redirectTo = '/login' }: ProtectedRouteProps) {
  const { state } = useAuth();
  const [, setLocation] = useLocation();

  // If auth status is still unknown, render placeholder to prevent flash
  if (state.status === 'unknown') {
    return <div className="min-h-screen" />;
  }

  // If unauthenticated, redirect to login
  if (state.status === 'unauthenticated') {
    console.log('[PROTECTED_ROUTE] Redirecting to login - user not authenticated');
    setLocation(redirectTo);
    return null;
  }

  // If authenticated, render children
  console.log('[PROTECTED_ROUTE] Rendering protected content - user authenticated');
  return <>{children}</>;
}

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export function PublicRoute({ children, redirectTo = '/campaigns' }: PublicRouteProps) {
  const { state } = useAuth();
  const [, setLocation] = useLocation();

  // If auth status is still unknown, render placeholder to prevent flash
  if (state.status === 'unknown') {
    return <div className="min-h-screen" />;
  }

  // If authenticated, redirect away from public pages like login
  if (state.status === 'authenticated') {
    console.log('[PUBLIC_ROUTE] Redirecting to app - user already authenticated');
    setLocation(redirectTo);
    return null;
  }

  // If unauthenticated, render public content (like login page)
  console.log('[PUBLIC_ROUTE] Rendering public content - user not authenticated');
  return <>{children}</>;
}
